// src/app/service/logout.guard.ts
import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { RoService } from './ro.service';
import { DataService } from './data.service';
import { HkedCityService } from './hkedCity.service';

@Injectable({
	providedIn: 'root'
})
export class LogoutGuard implements CanActivate {
	constructor(
		private router: Router,
		private datas: DataService, 
		private ros: RoService,
		private hkedCitys:HkedCityService, 
	) {}

	canActivate(): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
		this.ros.reset();
		if (this.hkedCitys.isLoginByHkedCity) {
			this.roLogout().then(()=>{
				this.hkedCitys.signOut(); // 香港教育城登出
			});

			return false;
		}

		this.roLogout();

		// 2. 直接導回 /login
		return this.router.createUrlTree(['/login']);
	}

	roLogout():Promise<void> {
		return this.datas.post2({ data: { api: 'Account.logout', json: [] } }).then(()=>{
			this.datas.logout();
		});
	}
}
